<template>
	<CSidebar
		fixed
		color-scheme="dark"
		:minimize="minimize"
		:show="show"
		@update:show="(value) => $store.commit('coreuiStore/set', ['sidebarShow', value])"
	>
		<CSidebarBrand class="d-md-down-none">
			<img
				v-if="!minimize"
				style="width: 80%;margin-bottom: 5%;margin-top: 5%;"
				:src="imgLogoWhite"
			/>
			<img
				v-else
				style="width: 100%;margin-bottom: 5%;margin-top: 5%;"
				:src="imgAvatarTransparent"
			/>
		</CSidebarBrand>
		<!-- <CRenderFunction flat :content-to-render="$options.nav" /> -->
		<CRenderFunction :content-to-render="computedSidebar" flat />
		<CSidebarMinimizer
			class="d-md-down-none"
			@click.native="$store.commit('coreuiStore/set', ['sidebarMinimize', !minimize])"
			title="Minimizar menú lateral"
			v-b-tooltip.hover.righttop.v-primary
		/>
	</CSidebar>
</template>

<script>
	import nav from './_nav';
	import { userProfiles } from '../constants/profilesUsers';

	export default {
		created() {},
		data() {
			return {
				imgLogoWhite: process.env.VUE_APP_LOGO_INFOGUIA_WHITE,
				//role: this.$store.state.userInfo.idprofiles,
				imgAvatarTransparent:
					process.env.VUE_APP_AVATAR_TRANSPARENT_INFOGUIA,
				role: JSON.parse(sessionStorage.getItem('userData')).id_profiles
			};
		},
		name: 'TheSidebar',
		// nav,
		computed: {
			show() {
				return this.$store.state.coreuiStore.sidebarShow;
			},
			minimize() {
				return this.$store.state.coreuiStore.sidebarMinimize;
			},
			currentItems() {
				if (this.role === userProfiles.none) {
					return [];
				}
				return nav.filter((item) => {
					return !item.roles || item.roles.includes(this.role);
				});
			},
			computedSidebar() {
				return [
					{
						_name: 'CSidebarNav',
						_children: this.currentItems,
					},
				];
			},
		},
	};
</script>
